import React from "react";
import { motion } from "framer-motion";
import { FaLinkedin } from "react-icons/fa";

const AboutUsBody2 = () => {
  return (
    <motion.section
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 1 }}
      className="max-w-7xl mx-auto py-20 px-6 bg-white text-center rounded-xl shadow-md"
    >
      <h2 className="text-4xl font-bold text-[#29313F] mb-8 tracking-wide">
        Meet Our Leadership
      </h2>

      {/* Main Container: Two columns on large screens, stacked on mobile */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {/* CEO Profile with LinkedIn */}
      
        <motion.div initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{ duration: 1 }} className="bg-gray-100 p-6 rounded-xl shadow-lg text-left hover:scale-105 transition-all">
          <img
            src="/CEO3.jpeg"
            alt="Aleksandra S Petric - CEO of Petriek Structures"
            className="rounded-lg object-cover w-full h-64 shadow-md hover:opacity-80 transition-opacity"
          />
          <h3 className="mt-4 text-xl font-bold text-gray-900">Aleksandra S Petric</h3>
          <p className="mt-2 font-semibold text-gray-700">FOUNDER / CEO</p>
          <p className="mt-2 text-gray-600 text-sm">
            Born in Hasselt, Overijssel, but moved to Veenendaal after
            a year. When he was 4 years old, his father gave him lessons
            for the first time and by the time he was 12 years old, he
            relocated to the United States of America.
            <br />
            With a strong background in leadership and construction excellence,
            Aleksandra has driven Petriek Structures to success with a vision of innovation and sustainability.
          </p>
          {/*
          <a href="https://www.linkedin.com/in/peterostdiek" target="_blank" rel="noopener noreferrer" className="inline-flex items-center mt-3 text-[#0077b5] hover:text-[#005582] transition">
            <FaLinkedin className="text-2xl mr-2" />
            <span className="font-medium">Connect on LinkedIn</span>
          </a>
          */}
        </motion.div>

        {/* President Profile with LinkedIn */}
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 1, delay: 0.4 }}
          className="bg-gray-100 p-6 rounded-xl shadow-lg text-left hover:scale-105 transition-all"
        >
          <img
            src="/president.jpeg"
            alt="Harry M Bart - President of Petriek Structures"
            className="rounded-lg object-cover w-full h-64 shadow-md hover:opacity-80 transition-opacity"
          />
          <h3 className="text-xl font-semibold text-[#29313F] mb-2">
            Harry M Bart
          </h3>
          <p className="text-gray-700">PRESIDENT</p>
          <p className="mt-2 text-gray-600 text-sm">
            Harry brings a wealth of experience in leadership and construction
            management, ensuring smooth execution of high-scale projects.
          </p>
          {/*
          <a
            href="https://www.linkedin.com/in/peterflanagan225"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center mt-3 text-[#0077b5] hover:text-[#005582] transition"
          >
            <FaLinkedin className="text-2xl mr-2" />
            <span className="font-medium">Connect on LinkedIn</span>
          </a>
          */}
        </motion.div>

        {/* Other Profiles */}
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 1, delay: 0.2 }}
          className="bg-gray-100 p-6 rounded-xl shadow-lg text-left hover:scale-105 transition-all"
        >
          <img
            src="/vice president.jpeg"
            alt="Doritha Donnell - Vice President of Petriek Structures"
            className="rounded-lg object-cover w-full h-64 shadow-md hover:opacity-80 transition-opacity"
          />
          <h3 className="text-xl font-semibold text-[#29313F] mb-2">
            Doritha Donnell
          </h3>
          <p className="text-gray-700 font-medium">
            EXECUTIVE VICE PRESIDENT
          </p>
          <p className="mt-2 text-gray-600 text-sm leading-relaxed">
            With over 20 years of experience in operations and executive
            leadership, Doritha has played a key role in driving strategic
            growth and ensuring operational excellence. She specializes in
            business transformation, operational efficiency, and leadership
            development. Throughout her career, she has successfully led
            large-scale initiatives that improved productivity, streamlined
            processes, and enhanced customer satisfaction.
            <br />
            <br />
            Prior to her current role, Doritha held executive positions at
            leading organizations, where she managed cross-functional teams,
            implemented innovative strategies, and fostered a culture of
            collaboration. She is passionate about mentorship and is dedicated
            to empowering future leaders in the industry. Her expertise in
            financial planning, risk management, and corporate governance has
            been instrumental in shaping the company’s long-term vision.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 1, delay: 0.6 }}
          className="bg-gray-100 p-6 rounded-xl shadow-lg text-left hover:scale-105 transition-all"
        >
          <img
            src="/head of finance.jpeg"
            alt="Stetson Mary - Head of finance of Petriek Structures"
            className="rounded-lg object-cover w-full h-64 shadow-md hover:opacity-80 transition-opacity"
          />
          <h3 className="text-xl font-semibold text-[#29313F] mb-2">
            Stetson Mary
          </h3>
          <p className="text-gray-700">
            HEAD OF FINANCE, ACCOUNTS & PROCUREMENT
          </p>
          <p className="mt-2 text-gray-600 text-sm">
            Stetson oversees the financial health of the company, managing
            budgets and procurement strategies to optimize operations.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 1, delay: 0.8 }}
          className="bg-gray-100 p-6 rounded-xl shadow-lg text-left hover:scale-105 transition-all"
        >
          <img
            src="/senior project manager.jpeg"
            alt="Ketterman Vondella - Senior project manager of Petriek Structures"
            className="rounded-lg object-cover w-full h-64 shadow-md hover:opacity-80 transition-opacity"
          />
          <h3 className="text-xl font-semibold text-[#29313F] mb-2">
            Ketterman Vondella
          </h3>
          <p className="text-gray-700">SENIOR PROJECT MANAGER</p>
          <p className="mt-2 text-gray-600 text-sm">
            With a strong background in project management, Ketterman ensures
            the successful execution of construction projects from inception to
            completion.
          </p>
        </motion.div>
      </div>
    </motion.section>
  );
};

export default AboutUsBody2;
